import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";
import { DeleteModal } from "shared/components";
import { copy } from "shared/assets";

import {
  dataMetaSelector,
  deleteEventScheduleBlockEntry,
  dispatchGetEventScheduleBlock,
} from "Bands/state";
import { BAND_ACTIONS, IScheduleBlockEntry } from "Bands/types";
import { useClearActionMetaOnUnMount } from "Bands/utils";

const deleteCopy = copy.scheduleBlock.deleteEntry;

interface DeleteScheduleBlockEntryModalProps {
  blockId: string;
  entry: IScheduleBlockEntry;
  handleClose: () => void;
}

export const DeleteScheduleBlockEntryModal: React.FC<DeleteScheduleBlockEntryModalProps> = ({
  blockId,
  entry: { id, title },
  handleClose,
}) => {
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.deleteEventScheduleBlockEntry)
  );

  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteEventScheduleBlockEntry);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleClose();

      // refetch block
      dispatchGetEventScheduleBlock(dispatch, blockId);

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: deleteCopy.messages.success,
        })
      );
    }
  }, [dispatch, apiMeta, handleClose, title, blockId]);

  const handleDelete = () => {
    dispatch(deleteEventScheduleBlockEntry(id));
  };

  return (
    <DeleteModal
      apiMeta={apiMeta}
      handleClose={handleClose}
      handleDelete={handleDelete}
      name={title}
      type="entry"
    ></DeleteModal>
  );
};
